import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {changeAzienda, selectIdAzienda, selectToken} from "@commons/core.slice";
import {useLocation} from "react-router-dom";
import React, {useState} from "react";
import useToggle from "@hooks/useToggle";
import {range} from "@commons/utils/util";
import {TokenRecord} from "@commons/mapping/TokenRecord";
import * as AuthActions from "@commons/actions/authentication.action";
import {logout, resetAccount} from "@commons/actions/authentication.action";
import {useListAziendeXEmployee} from "@commons/services/aziende/aziende.queries";
import {queryClient} from "@utilities/config.ReactQuery";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import {QueryClientProvider} from "@tanstack/react-query";
import {AziendaFruibileRecord} from "@commons/mapping/AziendaFruibileRecord";
import {changeDomainPlusAzienda} from "@commons/actions/environment.action";
import {ModalPanel} from "@components/Modal2023";
import {FilterPeriodType} from "@commons/filters";
import {PeriodoType} from "@commons/types";

export default function Welcome() {
    const token: TokenRecord | null = useAppSelector(selectToken);
    const location = useLocation();

    const [isModalOpen_, toggleIsModalOpen] = useToggle(false);
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

    const dispatch = useAppDispatch();

    //const {contratto}=useLavoratore2();
    function resetAccountTest(idUser: number) {

        dispatch(resetAccount({
            idUser,
            passwordInChiaro: 'Oggi1234!',
            email: 'sergiot@ericed.it'
        })).then((res) => {
            console.log(res.type);
            if (res.type === AuthActions.resetAccount.fulfilled.type) {
                dispatch(logout(token?.token!));
            } else if (res.type === AuthActions.resetAccount.rejected.type) {
            }
        }, () => {
            // NON CI VIENE MAI!!!
        });
    }

    function cambiaAzienda() {
        dispatch(changeAzienda({idAzienda: 2810, idAziendaMaster: 2810, URI: `/azienda/2810/ul/2810?mode=Navigator`}));
    }

    //usePresenzeWF({anno: 2024, mese: 3});
    /*
        const anteprimaParams: DocumentoParams = {
            start: 0,
            length: 0,
            idDip: 45539,
            sezione: 'DOC_PUBBLICI',
            anteprima: true,
            view: 'Grid',
            mode: 'DataTables',
        } as DocumentoParams;

        const {refetch, data: docsAndBadges, isLoading, isFetching} = useListDocuments(anteprimaParams);
    */
    //const [count, setCount] = React.useState(0);

    /*React.useEffect(() => {
        const intervalId = window.setInterval(() => {
            //setCount((currentCount) => currentCount + 1);
            setIsModalOpen(true)
        }, 3000);

        return () => {
            window.clearInterval(intervalId);
        };
    }, []);*/

    /*
        <Link to="/about">About</Link>
        <Link to="/users?page=10">Users</Link>
        <Link to="/users?page=10#myHash">Users

        Some of the properties you can access on the location object are:
            pathname - the current pathname, e.g. /users
            search - the current query string, e.g. ?page=10
            hash - the current hash, e.g. #myHash.
            */

    const defPeriodo = {
        type: 'custom' as PeriodoType,
        start: '20240501',
        end: '20240630',
    };
    const [PERIODO, setPeriodo] = useState<FilterPeriodType>(defPeriodo);
    /*const {data} = useMonitorWF({
        appliedFilters: true, PERIODO,
        STATO: [],
        ELABORATO: [],
        VALIDITA: [],
        CAUSALE: [],
        DIPENDENTE: [],
    })
*/

    return (<>
        {/*
        <AziendaNavContainer>
            <p className="p-5">Welcome!</p>
        </AziendaNavContainer>
*/}
        <p className="p-5">Id sessione (token): {token?.token}</p>
        {process.env.NODE_ENV === 'development' && <>
            <h2>Current Pathname: {location.pathname}</h2>
            <h2>Current Search: params {location.search}</h2>
            <h2>Current Hash: {location.hash}</h2>
            {/*
            <h2>is loading: {isLoading && 'loading...'}</h2>
            <h2>is fetching: {isFetching && 'Fetching...'}</h2>
            <button onClick={() => refetch()} className='bg-red-600'>refetch</button>
            <h2>docs: {docsAndBadges?.recordsTotal}</h2>
*/}
            {/*<ExampleSlider/>*/}
            {/*<TestSlider/>*/}
            {isModalOpen &&
                <ModalPanel
                    isOpen={isModalOpen}
                    header="Hello world"
                    //obscure={true}
                    handleDismiss={() => setIsModalOpen(val => !val)}
                >
                    This is an example modal! It includes <a href="">several</a> <a href="">different</a> <a href="">links</a>.
                </ModalPanel>
            }
            {false && range(0, 19).map((value, index, array) => {
                return <span key={value}>

                <p>
                    Lorem Ipsum is simply dummy text of the printing and typesetting
                    industry. Lorem Ipsum has been the industry's standard dummy text
                    ever since the 1500s, when an unknown printer took a galley of
                    type and scrambled it to make a type specimen book. It has
                    survived not only five centuries, but also the leap into
                    electronic typesetting, remaining essentially unchanged.
                </p>
                <p>
                    It was popularised in the 1960s with the release of Letraset
                    sheets containing Lorem Ipsum passages, and more recently with
                    desktop publishing software like Aldus PageMaker including
                    versions of Lorem Ipsum.
                </p>
                <button onClick={() => setIsModalOpen(val => !val)}>
                    Toggle modal
                </button>
            </span>
            })}

            <button className="text-blue-400 enabled:hover:text-blue-600" onClick={() => resetAccountTest(14958)}>Reset account #{14958}</button>
            <br/>
            <button className="text-blue-400 enabled:hover:text-blue-600" onClick={() => resetAccountTest(14959)}>Reset account #{14959}</button>
            <br/>
            <button className="text-blue-400 enabled:hover:text-blue-600" onClick={() => cambiaAzienda()}>Test cambio azienda</button>

            {/*<CCNLLivelloPage codContratto={'*'} codContrattoUNILAV={'*'}></CCNLLivelloPage>*/}

            <QueryClientProvider client={queryClient}>
                <ListAziende/>
                <ReactQueryDevtools initialIsOpen={false}/>
            </QueryClientProvider>

            {/*<Presenze1/>*/}

            <button className="m-3" onClick={() => setPeriodo({
                type: 'custom' as PeriodoType,
                start: '20230501',
                end: '20240630',
            })}>
                periodo pluriennale
            </button>
            <button className="m-3" onClick={() => setPeriodo(defPeriodo)}>
                reset periodo
            </button>

            {/*{data && data.map(({URI, idWF, data, stato, extraLabel, nome, cognome, noteObbligatorie, readOnly}) => {
                return <div key={URI}>
                        <span>
                            {`${nome} ${cognome} ${data} ${stato} ${readOnly ? 'RO' : ''}`}
                        </span>
                    {stato !== 'ACCETTATA' &&
                        stato !== 'RIFIUTATA' &&
                        stato !== 'ANNULLATA' &&
                        ((noteObbligatorie || readOnly) ? (
                            <>{extraLabel ? <span>{extraLabel}</span> :
                                <>{noteObbligatorie && <span>Note obbligatorie</span>}</>
                            }</>
                        ) : 'checkbox')}
                </div>
            })}*/}

        </>}
    </>)
}


const ListAziende: React.FC = () => {
    const dispatch = useAppDispatch();
    const idAzienda = useAppSelector(selectIdAzienda);
    const {data} = useListAziendeXEmployee({view: "Minimal"});
    const btnClass = `mt-2 inline-flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600
    hover:bg-blue-700
    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
    disabled:opacity-50
    `;
    const selAzienda = (azienda: AziendaFruibileRecord) => {
        dispatch(changeDomainPlusAzienda({idDominio: azienda.idDominio!, idAzienda: azienda.idAzienda}));
    }

    return <ul className="list-inside list-disc">

        {data && data.map((azienda) => {
            return <li key={azienda.idAzienda} className="w-full">
                <span className="inline-flex mr-2">{azienda.denominazione}</span>
                {idAzienda !== azienda.idAzienda &&
                    <button onClick={(e) => selAzienda(azienda)} className={btnClass}>Seleziona</button>}
            </li>
        })
        }
    </ul>;
}